module.exports = __webpack_public_path__ + "img/舍弗勒.png";